module.exports = __webpack_public_path__ + "img/gallery-5.8c4c9397.jpg";